export default {
  eyebrow: 'Partnerportal',
  title: 'Skat og valuta',
  description:
    'Standardskattekategorier, som dine restauranter arver, medmindre de tilsidesætter en kategori individuelt.',
};
